import { ErpInputTableV2 } from '@/components/custom/erp';
import { useAccountFormContext } from '../../context';
import { getConstraintColumns } from './cols';

function ConstraintsTab() {
  const form = useAccountFormContext();

  return (
    <div onChangeCapture={form.markDirty}>
      <ErpInputTableV2
        rows={form.constraints}
        columns={getConstraintColumns(form.mode, form.handleConstraintValueChange)}
        getRowId={row => row.id}
        selectedRowId={form.selectedConstraintRowId || undefined}
        pasteTarget={form.selectedConstraintCell}
        onRowClick={form.handleConstraintRowClick}
        onCellClick={form.handleConstraintCellClick}
        actionsDisabled
        actionOrder={[]}
      />
    </div>
  );
}

export default ConstraintsTab;
